import { Control } from './Control'
import type { AnswerProps } from './types'

// MAX_RUNES is the server's own limit on a text answer. Stopping the field here
// means the refusal never happens: a counter that will not go past the cap says
// the same thing as an error, before the person has typed the sentence.
const MAX_RUNES = 200

export function TextAnswer({ question, value, onChange }: AnswerProps) {
  return (
    <Control>
      <input
        className="field__control"
        type="text"
        aria-label={question.text}
        maxLength={MAX_RUNES}
        value={typeof value === 'string' ? value : ''}
        onChange={(event) => onChange(event.target.value || undefined)}
      />
    </Control>
  )
}
